import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';
import { REDUCER_NAME, changeDateRange } from './../reducer';
import PriceDataDate from './PriceDataDate';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';

class TimeFrame extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      datePicker: {
        from: props.dateRangeOption.FromDate,
        to: props.dateRangeOption.ToDate,
      },
    };
  }

  handleDateChange = itemDate => {
    const { componentId, changeDateRange } = this.props;
    const clone = {
      ...this.state.datePicker,
      from: itemDate.startDate ? itemDate.startDate : itemDate.endDate,
      to: itemDate.endDate ? itemDate.endDate : itemDate.startDate,
    };
    this.setState({ datePicker: clone });
    changeDateRange(clone, componentId);
  };

  showGuestPopup = () => {
    EventEmitter.dispatch(SHOW_GUEST_POPUP);
  };

  render() {
    const { dateRangeOption, user } = this.props;
    let nameFrom = I18n.t('priceData.lstTitleDate.from');
    if (isNotLoginOrExpired(user)) {
      return (
        <div onClick={this.showGuestPopup} className="price-data-lock-calendar">
          <PriceDataDate
            nameFrom={nameFrom}
            handleDateChange={this.handleDateChange}
            startDate={dateRangeOption.FromDate}
            endDate={dateRangeOption.ToDate}
          />
        </div>
      );
    }
    return (
      <PriceDataDate
        nameFrom={nameFrom}
        handleDateChange={this.handleDateChange}
        startDate={dateRangeOption.FromDate}
        endDate={dateRangeOption.ToDate}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    dateRangeOption:
      state[REDUCER_NAME].listMultiComponent[componentId].dateRangeOption,
    i18n: state.i18n,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeDateRange,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TimeFrame);
